import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Report } from "../../models/report.model";
import { ReportActivation } from "../../interfaces/reportActivation";
import { ReportRequest } from "../../models/reportRequest.model";
import { GeneratePdfBase64Response } from "../../models/generate-pdf.model";
import { AttendanceFilter } from "src/app/modules/attendance/models/attendance-filter.model";

export namespace ReportActions {

  @logDispatcher
  export class GetReportsCfg {
    static readonly type = '[Reports] ReportsCfg';
    constructor() {}
  }

  @logDispatcher
  export class GetReports {
    static readonly type = '[Reports] GetReports';
    constructor(public vertical: number, public description: string, public language: string, public status: string) {}
  }

  @logDispatcher
  export class GetReportsSuccess {
    static readonly type = '[Reports] GetReportsSuccess'
    constructor(public result: Report[]) {}
  }

  @logDispatcher
  export class GetReportDetails {
    static readonly type = '[Reports] GetReportDetails';
    constructor(public reportId: string, public vertical: number) { }
  }

  @logDispatcher
  export class AddReport {
    static readonly type = '[Reports] AddReport'
    constructor(public report: Report) {}
  }

  @logDispatcher
  export class AddReportSuccess {
    static readonly type = '[Reports] AddReportSuccess'
    constructor(public report: Report) {}
  }

  @logDispatcher
  export class EditReport {
    static readonly type = '[Reports] EditReport'
    constructor(public report: ReportRequest) {}
  }

  @logDispatcher
  export class EditReportSuccess {
    static readonly type = '[Reports] EditReportSuccess'
    constructor(public report: ReportRequest) {}
  }

  @logDispatcher
  export class GenerateFamilyReport {
    static readonly type = '[Reports] GenerateReport'
    constructor(public reportName: string, public familyId: number, public exerciseId: number) {}
  }

  @logDispatcher
  export class GenerateFamilyReportSuccess {
    static readonly type = '[Reports] GenerateReportSuccess'
    constructor(public generatePdfBase64Response: GeneratePdfBase64Response) {}
  }

  @logDispatcher
  export class SetActivation {
    static readonly type = '[Reports] SetActivation'
    constructor(public reportActivation: ReportActivation) {}
  }

  @logDispatcher
  export class DeleteReport {
    static readonly type = '[Reports] DeleteReport'
    constructor(public id: number, public name: string) {}
  }

  @logDispatcher
  export class DeleteReportSuccess {
    static readonly type = '[Reports] DeleteReportSuccess'
    constructor(public id: number) {}
  }

  @logDispatcher
  export class GetStudentEngagementReport  {
      static readonly type = '[Reports] GetStudentEngagementReport';
      constructor() {}
  }

  @logDispatcher
  export class GetStudentEngagementReportSuccess  {
      static readonly type = '[Reports] GetStudentEngagementReportSuccess';
      constructor(public generatePdfBase64Response: GeneratePdfBase64Response) {}
  }

  @logDispatcher
  export class SetStudentEngagementListCurrentExercise  {
      static readonly type = '[Reports] SetSStudentEngagementListCurrentExercise';
      constructor(public exerciseId: number) {}
  }

  @logDispatcher
  export class GetStudentsAttendancesReport  {
      static readonly type = '[Reports] GetStudentsAttendancesReport';
      constructor(public filters: AttendanceFilter, public showData: boolean, public orderAttendance: number) {}
  }

  @logDispatcher
  export class GetStudentsAttendancesReportSuccess  {
      static readonly type = '[Reports] GetStudentsAttendancesReportSuccess';
      constructor(public generatePdfBase64Response: GeneratePdfBase64Response) {}
  }

  @logDispatcher
  export class Error {
      static readonly type = '[Reports] Error';
      constructor(public error: any, public details: string) { }
  }

  @logDispatcher
  export class SetDefaultState  {
      static readonly type = '[Reports] SetDefaultState';
      constructor(public reportDefaults: Report) {}
  }

  @logDispatcher
  export class SetReportDefaultState  {
      static readonly type = '[Reports] SetReportDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetReportAddDefaultState {
    static readonly type = '[Reports] SetReportAddDefaultState';
    constructor() {}
  }
}
